<template>
<div v-if='lod_show != 0' id='loading'>

	<!-- <div :class="{'lo-model no-copy':true, 'lo-model-show':loading_show}">
		<img class='lo-model-icon' src='@/assets/icon/loading.png' />
		<div class='lo-model-font font-14'>正在加载中....</div>
	</div> -->
	<div :class="{'lod-mask':true, 'lod-mask-show':lod_show===2}">
		<div :class="{'lod-model no-copy':true, 'lod-model-show':lod_show===2}">
			<img class='lod-model-icon' src='@/assets/icon/loading.png' />
			<div class='lod-model-title font-14 color-body'>{{title}}</div>
		</div>
	</div>

</div>
</template>
<script>
export default {
	name: 'loading',
	props: {},
	data() {
		return {
			lod_show: 0,
			title: '加载中...',
		}
	},
	methods: {
		// show方法
		vLod_Change(show, title) {
			if (!show && this.lod_show===0) {
				return;
			} else if (!show && this.lod_show===2) {
				this.vLod_close();
				return;
			}

			if (title && title.constructor['name']==='String') this.title=title;

			this.lod_show = 1;
			setTimeout(() => {
				this.lod_show = 2;
			}, 20)
		},
		// close方法
		vLod_close() {
			this.lod_show = 1;
			setTimeout(() => {
				this.lod_show = 0;
			}, 200)
		},
	}
}
</script>
<style scoped>
.lod-mask {
	background:rgba(55, 55, 55, 0);
	width:100%; height:100vh;
	position:fixed; top:0; left:0;
	transition: all 0.2s ease-in-out 0s;
	z-index:400;
}
.lod-mask-show {
	background:rgba(55, 55, 55, .3);
}
.lod-model {
	background:#ffffff;
	width:190px; height:40px; margin:120px auto 0 auto;
	display:flex; justify-content:center; align-items:center;
	border-radius:4px;
	box-shadow: 0 1px 6px rgba(0, 0, 0, .2);
	opacity:0;
	transform: scale(1.285);
	transition: all 0.2s ease-in-out 0s;
}
.lod-model-show {
	opacity:1;
	transform: scale(1);
}
.lod-model-icon {
	width:20px; height:20px;
	animation: roating .6s linear 0s infinite;
}
@keyframes roating
{
	from {transform:rotate(0deg);}
	to {transform:rotate(360deg);}
}
.lod-model-title {
	width:calc(100% - 56px); margin-left:10px;
	text-overflow:ellipsis; white-space:nowrap; overflow:hidden;
}
</style>




// WEBPACK FOOTER //
// src/components/popup/Loading.vue